import { Outlet, createFileRoute } from "@tanstack/react-router";

import VStack from "@/components/Layout/VStack";

import PersonProfileHeader from "../-components/PersonProfileHeader";

export const Route = createFileRoute("/_staff/person/$id/_profile")({
  component: PersonProfile,
});

function PersonProfile() {
  return (
    <VStack>
      <PersonProfileHeader />
      <Outlet />
    </VStack>
  );
}
